// The Men's / Women's switch in row 1 (Ranking, Filter, Stats Table; Ben, 2026-11-02). The same
// two-way button as the readout's Per 90 / Total: it names the side shown, a click goes to the other.

import { GENDER_LABELS, sideOf } from "../live/gender-switch.js";

export function GenderSwitch({ womens, onFlip }: { womens: boolean | null; onFlip: () => void }) {
  if (womens === null) return null;
  const side = sideOf(womens);
  return (
    <button type="button" className="value-mode-toggle gender-toggle" data-mode={side} onClick={onFlip}>
      {GENDER_LABELS[side]}
    </button>
  );
}
